import i18n from 'i18next';

import { initReactI18next } from 'react-i18next';

import translations from './lang.json';

i18n.use(initReactI18next).init({
  resources: { translations },
  lng: 'translations',
  preload: ['translations'],
  defaultNS: 'fr_FR',
  interpolation: { escapeValue: false },
});

export type Translations = keyof (typeof translations)['fr_FR'];

export default i18n;
